
export const TableStatus = {
    AVAILABLE: 'AVAILABLE',
    OPENED: "OPENED",
    PRECLOSED: "PRECLOSED",
    CLOSED: "CLOSED",
};

export class TableOverview {
    
    /**
     *
     * @param {Object} table
     * @param {Object} table.status - Situação da mesa
     * @param {String} table.fee -  Taxa da mesa
     * @param {String} table.subtotal -  Subtotal da mesa
     * @param {String} table.total -  Total da mesa
     * @param {TableItem[]} table.items - Itens da mesa
     * @param {number} table.payersQuantity - Número de pagantes da mesa
     * @return {TableOverview} 
     */
    constructor ({ status, fee, subtotal, total, items, payersQuantity }) {
        /**
         * Situação da mesa
         * @type {String}
         */
        this.status = status;


        /**
         * Taxa da mesa
         * @type {number}
         */
        this.fee = fee;
        
        /**
         * Subtotal da mesa
         * @type {number}
         */
        this.subtotal = subtotal;

        /**
         * Total da mesa (valor cobrado)
         * @type {number}
         */
        this.total = total;

        /**
         * Itens da mesa
         * @type {TableItem[]}
         */
        this.items = items;

        /**
         * Número de pagantes da mesa
         * @type {number}
         */
        this.payersQuantity = payersQuantity;
    }

}
